import { useContext } from 'react';
import { Link } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import PersonInsurancePolicy from '@/components/PersonInsurancePolicy';
import { Color } from '@/constants/color';
import useBetaFeature from '@/hooks/useBetaFeature';
import useNavigateToPage from '@/hooks/useNavigateToPage';
import PersonContext from '@/pages/Person/PersonContext';
import { Alert } from '@/ui';
import Button from '@/ui/components/Button';
import Container from '@/ui/components/Container';

const PersonInsurance = () => {
  const {
    person: { id: personId, insurance_policies }
  } = useContext(PersonContext);
  const { navigateToVOBList } = useNavigateToPage();
  const { isEnabled: isDeprecated } = useBetaFeature('profileInsurance');

  return (
    <Container type="page">
      {isDeprecated && (
        <Alert variant="warning" className="mb-4">
          <strong>Deprecated.</strong> This page is going away. Verify, edit and review policies in
          the{' '}
          <Link to={`/people/${personId}#insurance`} className="font-medium underline">
            Insurance panel on the Profile page
          </Link>
          .
        </Alert>
      )}
      <div className="flex items-center justify-between">
        <PageHeader headingText="Insurance policies" />
        <Button
          ariaLabel="All VOBs for this member"
          color={Color.WHITE}
          size="sm"
          onClick={() => navigateToVOBList({ member_id: personId })}>
          All VOBs
        </Button>
      </div>
      {insurance_policies.map((insurancePolicy) => (
        <PersonInsurancePolicy key={insurancePolicy.id} insurancePolicy={insurancePolicy} />
      ))}
    </Container>
  );
};

export default PersonInsurance;
